import { useChat } from "../../../fetch/fetch.chat.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import { EMPTY_CHAT } from "../../../const/typeDefault/Chat.ts";
import { ChatType } from "../../../types/Chat.ts";
import { ReactNode } from "react";

const FetchChat = ({
  id,
  children,
  fallback,
}: {
  id: string;
  children: (chat: ChatType) => ReactNode;
  fallback: ReactNode;
}) => {
  const { chat, isLoading, isError } = useChat(id, EMPTY_CHAT);
  if (isLoading) return fallback;
  if (isError) return <ErrMessage message={isError.message} />;
  return children(chat);
};
export default FetchChat;
